// ============================================================
// Inqi — Changelog público (alimenta la vista /changelog)
// ============================================================
//
// Versionado por superficie:
//   - web → versión del Panel web (inqi-front, ver package.json)
//   - app → versión de la App móvil (inqi-mobile, versión de tienda)
// Incluí en `versions` solo las superficies que tocó el release.
// Semver: feature → minor, fix-only → patch. Entradas más nuevas arriba.
//
// Forma de cada entrada:
//   {
//     date: 'YYYY-MM-DD',
//     title: string,
//     summary?: string,
//     versions: { web?: 'x.y.z', app?: 'x.y.z' },
//     sections: [{ surface: 'web' | 'app', items: [{ tag, text }] }]
//   }
// Tags: 'nuevo' | 'mejora' | 'fix' | 'eliminado' | 'seguridad' | 'admin'

export const changelog = [
  {
    date: '2026-09-03',
    title: 'La recaudación de cada propiedad ahora muestra si el comprobante cuadra',
    summary: 'Para saber si el depósito de un expositor coincidía con lo que debía había que salir a su ficha, entrar a sus letras y buscar la del mes. Ahora eso se ve dentro de la propiedad: la verificación del comprobante en la misma fila y, al abrir el expositor, sus letras del mes con la imagen del comprobante a un clic.',
    versions: { web: '2.24.0' },
    sections: [
      {
        surface: 'web',
        items: [
          { tag: 'nuevo', text: 'En Recaudación de una propiedad, cada expositor muestra el resultado de la verificación de su comprobante y cuántos tiene. Si tiene varias letras en el mes, manda la que pide revisión' },
          { tag: 'nuevo', text: 'Al hacer clic en un expositor se abren sus letras del mes: monto, vencimiento, fecha de pago y estado, cada una con su propia verificación y un botón para ver el comprobante o registrar el pago' },
          { tag: 'nuevo', text: 'Se ve el comprobante y se resuelve la alerta —darla por revisada, reabrirla o volver a verificar— sin salir de la propiedad. Lo que guardes se refleja al momento en el esperado, recaudado y pendiente de arriba' },
          { tag: 'fix', text: 'Los comprobantes que sube el expositor desde su app ya se ven al abrir una letra pagada. Antes el listado los contaba y la letra aparecía vacía' },
          { tag: 'mejora', text: 'Las filas de expositor con atraso ya no llevan una franja de color al costado: el estado se lee en el texto, que es donde se estaba mirando' }
        ]
      }
    ]
  },
  {
    date: '2026-09-02',
    title: 'Cuatro categorías nuevas de gasto, y la descripción deja de borrarse al pagar',
    summary: 'Casi dos de cada tres gastos estaban cargados como «Misceláneos» simplemente porque no había dónde más ponerlos. Se agregan Obra, Mantenimiento, Limpieza e insumos y Marketing y eventos, elegidas a partir de lo que ya estaba registrado. Aparte, se corrigió un error por el que registrar el pago de un gasto borraba su descripción.',
    versions: { web: '2.23.0' },
    sections: [
      {
        surface: 'web',
        items: [
          { tag: 'nuevo', text: 'Nuevas categorías de gasto: Obra, Mantenimiento, Limpieza e insumos, y Marketing y eventos. «Misceláneos» queda para lo que de verdad no encaja en ninguna' },
          { tag: 'fix', text: 'Al registrar el pago de un gasto, la observación ya no se borra: el formulario abre con la descripción que el gasto tiene y se puede completar. Antes se guardaba en blanco si no se volvía a escribir' },
          { tag: 'fix', text: 'Adjuntar comprobantes al registrar un pago ya no reemplaza los que el gasto pudiera tener: se suman' },
          { tag: 'mejora', text: 'El listado de categorías es ahora el mismo en el panel y en la app; antes cada uno ofrecía una lista distinta' }
        ]
      }
    ]
  },
  {
    date: '2026-09-02',
    title: 'Un gasto ya registrado se puede corregir o eliminar',
    summary: 'Hasta ahora sólo se podía editar un gasto mientras estuviera pendiente: una vez marcado como pagado quedaba fijo, y no había forma de borrar uno cargado por error. Las dos cosas están disponibles, y ambas piden confirmación antes de ejecutarse.',
    versions: { web: '2.22.0' },
    sections: [
      {
        surface: 'web',
        items: [
          { tag: 'nuevo', text: 'Editar sirve también para los gastos ya pagados, no sólo para los pendientes' },
          { tag: 'nuevo', text: 'Cada gasto se puede eliminar desde el listado' },
          { tag: 'mejora', text: 'Antes de guardar una edición aparece el detalle de qué cambia — monto, moneda, propiedad, tipo, vencimiento u observación — con el valor anterior y el nuevo' },
          { tag: 'mejora', text: 'Antes de eliminar se muestra de qué gasto se trata, si ya estaba pagado y cuántos comprobantes tiene adjuntos' },
          { tag: 'mejora', text: 'Al corregir o eliminar un gasto desde la ficha de una propiedad, el resultado del local se vuelve a calcular al regresar a la pestaña' }
        ]
      }
    ]
  },
  {
    date: '2026-08-31',
    title: 'Los nueve locales de Alejandro Agreda ahora son una sola propiedad: AAC',
    summary: 'Cada uno de esos locales tenía un solo inquilino, así que el filtro por propiedad tenía nueve opciones que no agrupaban nada. Ahora los nueve están dentro de AAC, y cada inquilino lleva su local en el nombre para poder distinguirlos y buscarlos.',
    versions: {},
    sections: [
      {
        surface: 'web',
        items: [
          { tag: 'mejora', text: 'El filtro por propiedad pasa de trece opciones a cinco: los nueve locales sueltos quedaron dentro de AAC' },
          { tag: 'mejora', text: 'Esos nueve inquilinos ahora se llaman «nombre — local», por ejemplo «VILLASOL — Arias 177 B Lt. 3B». También se puede buscar por el local: escribir «Cusco» encuentra los tres' },
          { tag: 'admin', text: 'El propietario de AAC quedó registrado como Alejandro Agreda' }
        ]
      }
    ]
  },
  {
    date: '2026-08-30',
    title: 'La columna de comprobantes ya no dice «Sin verificar»',
    summary: 'Esa etiqueta salía en casi todas las letras —porque los comprobantes anteriores a esta semana no se revisan— y confundía más de lo que informaba. Ahora la columna sólo muestra un estado cuando hay algo que decir; el resto del tiempo indica cuántos comprobantes tiene la letra.',
    versions: { web: '2.21.1' },
    sections: [
      {
        surface: 'web',
        items: [
          { tag: 'mejora', text: 'La columna Comprobante sólo muestra el resultado cuando la letra fue revisada; si no, dice cuántos comprobantes tiene y nada más' }
        ]
      }
    ]
  },
  {
    date: '2026-08-30',
    title: 'Una alerta de comprobante se puede cerrar a mano',
    summary: 'La lectura automática también se equivoca, así que ahora cualquier alerta se puede dar por revisada dejando dicho por qué. Y en el listado de letras ya no hay un botón que abría sólo el primer comprobante cuando había varios.',
    versions: { web: '2.21.0' },
    sections: [
      {
        surface: 'web',
        items: [
          { tag: 'nuevo', text: 'Botón «Dar por revisada» en la letra: cierra la alerta y guarda quién la cerró y por qué. Se puede reabrir cuando haga falta' },
          { tag: 'fix', text: 'Fuera el enlace «Ver» del listado de letras: abría siempre el primer comprobante, así que con varios adjuntos daba a entender que se habían visto todos. En su lugar dice cuántos hay, y se ven completos al abrir la letra' }
        ]
      }
    ]
  },
  {
    date: '2026-08-30',
    title: 'Los comprobantes de pago se revisan solos',
    summary: 'Cada comprobante que se adjunta a una letra se lee automáticamente y se compara con el monto registrado. Si no coincide, la letra queda marcada y les llega un aviso a los administradores. La letra no se bloquea ni se desactiva: sigue igual, sólo señalada.',
    versions: { web: '2.20.0' },
    sections: [
      {
        surface: 'web',
        items: [
          { tag: 'nuevo', text: 'La columna Comprobante de cada letra ahora dice si el monto del voucher coincide con lo registrado, si sobra plata, si está en otra moneda o si no se pudo leer' },
          { tag: 'nuevo', text: 'Aviso al celular de los administradores cuando un comprobante no cuadra, con el inquilino, la propiedad, el mes y cuánto falta' },
          { tag: 'nuevo', text: 'En Letras pendientes hay una vista «Con alerta» que junta todas las letras observadas, incluidas las que ya figuran pagadas' },
          { tag: 'mejora', text: 'Al registrar un pago ahora se ven los comprobantes que el inquilino mandó desde el app: antes existían pero no aparecían en esa pantalla' },
          { tag: 'mejora', text: 'Botón para volver a verificar un comprobante, por si se adjuntó una foto mejor' },
          { tag: 'fix', text: 'Editar una letra ya no pisa el resultado de su verificación' }
        ]
      }
    ]
  },
  {
    date: '2026-08-29',
    title: 'La lista de inquilinos del app va agrupada por propiedad',
    summary: 'En Inquilinos, con «Todas» puesto, la lista se parte por propiedad y cada una arranca plegada: se ve cuántos inquilinos tiene y cuántos están atrasados sin bajar la pantalla, y se abre sólo la que interesa.',
    versions: { app: '1.8.0' },
    sections: [
      {
        surface: 'app',
        items: [
          { tag: 'nuevo', text: 'Con «Todas» puesto, la lista se agrupa por propiedad y cada grupo se abre y se cierra desde su nombre' },
          { tag: 'mejora', text: 'Las propiedades arrancan plegadas: la pantalla entra de un vistazo con todas y su resumen —cuántos inquilinos y cuántos atrasados— en vez de con la lista corrida' },
          { tag: 'mejora', text: 'Al buscar se abren solas las propiedades que tienen resultados; al borrar la búsqueda vuelven a plegarse' },
          { tag: 'mejora', text: 'Eligiendo una propiedad en las pastillas la lista sigue siendo corrida, sin cabeceras: el nombre ya lo dice la pastilla' }
        ]
      }
    ]
  },
  {
    date: '2026-08-29',
    title: 'Filtros de Expositores separados, y la lista de inquilinos del app más fácil de leer',
    summary: 'Los filtros de arriba del listado de expositores ahora están rotulados y separados —«Propiedad» por un lado, «Estado» por el otro— y las propiedades arrancan plegadas, así se ve el resumen de las doce en una sola pantalla. En la app, el nombre del inquilino pasa a ocupar la fila entera.',
    versions: { web: '2.19.0', app: '1.7.2' },
    sections: [
      {
        surface: 'web',
        items: [
          { tag: 'mejora', text: 'El filtro por propiedad pasó a pastillas, como en la app. Con trece locales las pestañas se partían en dos líneas y se veían desordenadas' },
          { tag: 'mejora', text: 'Cada filtro va rotulado y en su propia fila: «Propiedad» arriba, «Estado» debajo. Antes eran dos tiras iguales, con un «Todos» en cada una, y se confundían entre sí' },
          { tag: 'mejora', text: 'Al entrar a Expositores las propiedades arrancan plegadas: se ve cuántos expositores tiene cada una y cuántos están atrasados sin bajar la pantalla, y se abre sólo la que interesa' },
          { tag: 'mejora', text: 'Al buscar se abren solas las propiedades que tienen resultados; al borrar la búsqueda vuelven a plegarse' }
        ]
      },
      {
        surface: 'app',
        items: [
          { tag: 'mejora', text: 'En Inquilinos el nombre ocupa la fila entera, y debajo van la propiedad, el día de pago, el estado y el monto. Los nombres largos ya no se parten contra la columna de la derecha' },
          { tag: 'eliminado', text: 'Los círculos con las iniciales de cada inquilino' },
          { tag: 'fix', text: 'El nombre se muestra tal como está guardado, con sus espacios: antes la pantalla los juntaba y no coincidía con lo que se ve en el panel' }
        ]
      }
    ]
  },
  {
    date: '2026-08-28',
    title: 'Nombres de propiedades prolijos, filtros más claros y bloques que se pliegan',
    summary: 'Los nueve locales que estaban guardados todo en mayúscula pasaron a escribirse como una dirección: «JR CUSCO 720» ahora es «Jr. Cusco 720». El cambio no es sólo de pantalla — el nombre nuevo también quedó en las letras y contratos ya emitidos, así que la propiedad se llama igual en todos lados. Además la barra de filtros se rediseñó y, en el listado de expositores, cada propiedad se puede plegar.',
    versions: { web: '2.18.0' },
    sections: [
      {
        surface: 'web',
        items: [
          { tag: 'mejora', text: 'Los locales que estaban en mayúscula ahora se escriben como dirección: Av. Argentina 274, Av. Aviación, Av. Emancipación 152 y 440, Cl. Manufacturas 146, Jr. Cusco 720, 732 y 738, y Arias 177 B Lt. 3B' },
          { tag: 'mejora', text: 'El nombre nuevo también quedó en las letras y contratos ya emitidos de esos locales, no sólo en la ficha de la propiedad' },
          { tag: 'mejora', text: 'Buscadores, desplegables y ordenamientos de todo el panel: más altos, con el contorno visible y con el borde marcado al pararse encima. Antes se confundían con el fondo de la página' },
          { tag: 'nuevo', text: 'Todos los buscadores del panel traen una × para borrar lo escrito de un click (o con la tecla Esc)' },
          { tag: 'nuevo', text: 'En Expositores, un botón «Limpiar filtros» que aparece cuando hay alguno puesto y devuelve la lista a como estaba' },
          { tag: 'nuevo', text: 'En «Todos», cada propiedad se pliega y despliega desde su nombre. Plegada sigue mostrando cuántos expositores tiene y cuántos están atrasados, así se puede ver el resumen de las doce propiedades en una sola pantalla' },
          { tag: 'mejora', text: 'El nombre de cada propiedad en el listado se ve bastante más grande' },
          { tag: 'mejora', text: 'Mientras se busca, ninguna propiedad queda plegada: si un expositor coincide, se ve' }
        ]
      }
    ]
  },
  {
    date: '2026-08-28',
    title: 'Expositores: una pestaña por propiedad, y «Todos» agrupado',
    summary: 'La lista de expositores se corta por propiedad, como en la app: arriba hay una pestaña por local, y en «Todos» la lista sale agrupada, con el nombre de la propiedad encabezando cada bloque. Antes la propiedad se elegía en un desplegable y, mirando todas juntas, había que leer el nombre del local repetido fila por fila para saber quién era de dónde.',
    versions: { web: '2.17.0' },
    sections: [
      {
        surface: 'web',
        items: [
          { tag: 'nuevo', text: 'Pestañas por propiedad arriba de la lista, con cuántos expositores tiene cada una' },
          { tag: 'nuevo', text: 'En «Todos» la lista va agrupada por propiedad: cada bloque arranca con el nombre del local, cuántos expositores tiene y cuántos están atrasados' },
          { tag: 'mejora', text: 'Las propiedades se ordenan de la que más expositores tiene a la que menos, y el mismo orden vale para las pestañas y para los bloques' },
          { tag: 'mejora', text: 'Los contadores acompañan al filtro: si buscás o filtrás por estado, el número de cada pestaña es exactamente lo que vas a ver al entrar' },
          { tag: 'eliminado', text: 'Quitado el desplegable «Todas las propiedades»: lo reemplazan las pestañas' },
          { tag: 'mejora', text: 'En pantalla angosta la pestaña abierta se desliza sola hasta quedar a la vista, así siempre se ve qué propiedad se está mirando' },
          { tag: 'fix', text: 'Corregido: cambiar entre Activos e Inactivos podía duplicar la lista entera —cada expositor dos veces y todos los contadores al doble— hasta recargar la página' },
          { tag: 'fix', text: 'Corregido: mirando los expositores dados de baja, el contador de arriba los llamaba «activos»' }
        ]
      }
    ]
  },
  {
    date: '2026-08-28',
    title: 'Un solo mes para toda la ficha de la propiedad, y buscador en Recaudación',
    summary: 'La ficha de una propiedad ahora tiene un único selector de mes arriba, y manda sobre las cuatro pestañas: te cambiás a julio y Balance, Recaudación, Gastos e Impuestos se van todos a julio. Antes cada pestaña traía su propio filtro y cada uno funcionaba distinto, así que se podía estar viendo un mes en una pestaña y otro en la de al lado sin darse cuenta.',
    versions: { web: '2.16.0' },
    sections: [
      {
        surface: 'web',
        items: [
          { tag: 'nuevo', text: 'Buscador de expositores en Recaudación: escribís parte del nombre y la lista se filtra. Las tres cifras de arriba no se mueven — siguen siendo las del local completo' },
          { tag: 'mejora', text: 'El buscador encuentra igual aunque el nombre esté guardado con espacios de más: tecleás lo que ves en pantalla y aparece' },
          { tag: 'nuevo', text: 'Recaudación suma filtros por estado (Todos / Pendientes / Pagados) y ordenamiento, igual que Gastos e Impuestos' },
          { tag: 'fix', text: 'Corregido: al abrir Gastos dentro de una propiedad podían aparecer por un instante gastos de otras propiedades' },
          { tag: 'fix', text: 'Corregido: cambiar de mes varias veces seguidas podía mezclar dos meses en la misma pantalla' },
          { tag: 'mejora', text: 'El buscador de Expositores y el de Ventas encuentran igual con nombres guardados con espacios de más' },
          { tag: 'mejora', text: 'El mes se elige una sola vez, arriba, y vale para las cuatro pestañas de la propiedad' },
          { tag: 'mejora', text: 'Gastos e Impuestos quedan con la misma barra de filtros y en el mismo orden: estado, buscador y ordenamiento' },
          { tag: 'nuevo', text: 'Buscador por tipo en Impuestos' },
          { tag: 'mejora', text: 'En Gastos, fuera de la ficha de propiedad, el filtro de fecha pasa a ser el mismo de Ventas, con rango de fechas propio' }
        ]
      }
    ]
  },
  {
    date: '2026-08-28',
    title: 'Recaudación: el Pendiente es el Esperado menos lo Recaudado',
    summary: 'El Pendiente de cada local vuelve a ser la renta del mes menos lo cobrado, sobre los mismos expositores activos. Si en un mes se cobró más que la renta —adelantos, letras de otros meses— la cifra sale en negativo, que es justamente lo que hay que ver. Royal Home 2 queda en $2,870.00 en agosto, y en junio en -$4,753.00.',
    versions: { web: '2.15.7' },
    sections: [
      {
        surface: 'web',
        items: [
          { tag: 'mejora', text: 'El Pendiente de cada local es Esperado − Recaudado, y sale en negativo cuando se cobró por encima de la renta del mes' },
          { tag: 'mejora', text: 'Cada fila muestra cuánto le falta a ese expositor para completar su renta del mes, así las filas suman el Pendiente del local' },
          { tag: 'eliminado', text: 'Quitado el aviso de "se emitieron letras por más/menos que los contratos": esa diferencia ya se ve dentro del Pendiente' }
        ]
      }
    ]
  },
  {
    date: '2026-08-28',
    title: 'Recaudación: los expositores dados de baja ya no entran en ninguna cifra',
    summary: 'Dar de baja a un expositor es la forma de sacarlo del cálculo, y ahora eso vale para las tres cifras: esperado, recaudado y pendiente. Antes sus letras seguían sumando en lo recaudado y en lo pendiente aunque su ficha estuviera dada de baja. En agosto, Royal Home 2 pasa a $88,765.76 recaudado y $2,030.00 pendiente.',
    versions: { web: '2.15.6' },
    sections: [
      {
        surface: 'web',
        items: [
          { tag: 'fix', text: 'Lo recaudado y lo pendiente cuentan solo letras de expositores activos, igual que el monto esperado. Un expositor dado de baja deja de aparecer y sus letras dejan de sumar' },
          { tag: 'mejora', text: 'El local de cada letra se toma de la ficha del expositor y no de la copia guardada en la letra, así un cambio de local se refleja al instante' }
        ]
      }
    ]
  },
  {
    date: '2026-08-28',
    title: 'App: la recaudación del mes ya cuadra con el panel',
    summary: 'La app mostraba dos cifras mal en Inicio y en el detalle de cada local. El "Recaudado" contaba una sola letra por expositor, así que quien tenía varias sumaba de menos. Y el "Pendiente" salía de restarle lo recaudado a la meta del mes, dos cifras que no cubren a la misma gente: ahora suma las letras del mes sin pagar, que es lo que de verdad falta cobrar.',
    versions: { app: '1.7.1' },
    sections: [
      {
        surface: 'app',
        items: [
          { tag: 'fix', text: 'El "Recaudado" del mes suma todas las letras pagadas: antes contaba solo la primera de cada expositor. En agosto se quedaba corto por $15,917 ($11,465 en Royal Home 2 y $4,452 en Royal Home 1)' },
          { tag: 'fix', text: 'El "Pendiente" es ahora la suma de las letras del mes sin pagar y ya no puede salir negativo. En agosto, Royal Home 2 pasa de $1,070 a $3,230, y el total de todos los locales de $22,618 a $25,178' },
          { tag: 'mejora', text: 'Las letras se cuentan por su mes de vencimiento, igual que en el panel: una letra de junio pagada en julio cuenta en junio' }
        ]
      }
    ]
  },
  {
    date: '2026-08-27',
    title: 'Expositores: el listado sin el círculo de iniciales',
    summary: 'La lista de expositores ya no muestra el círculo con las iniciales al lado de cada nombre. Las filas quedan más compactas y el estado de pago se sigue leyendo igual de claro: la franja de color a la izquierda y la etiqueta de la derecha.',
    versions: { web: '2.15.4' },
    sections: [
      {
        surface: 'web',
        items: [
          { tag: 'eliminado', text: 'Expositores: quitado el círculo con las iniciales junto al nombre de cada expositor' }
        ]
      }
    ]
  },
  {
    date: '2026-08-27',
    title: 'Recaudación: el "Pendiente" ahora suma las letras que faltan cobrar',
    summary: 'El "Pendiente" se calculaba restando lo recaudado a la meta del mes, y esas dos cifras no cubrían a la misma gente: la meta sale de los contratos de expositores activos y lo recaudado sumaba todas las letras pagadas del local. Por eso podía salir más chico de lo real, e incluso negativo. Ahora el Pendiente es la suma de las letras del mes sin pagar: lo que de verdad falta cobrar.',
    versions: { web: '2.15.3' },
    sections: [
      {
        surface: 'web',
        items: [
          { tag: 'fix', text: 'El "Pendiente" de cada local es ahora la suma de las letras del mes sin pagar. En agosto, Royal Home 2 mostraba $1,370 cuando faltaban $3,530' },
          { tag: 'fix', text: 'El "Pendiente" ya no puede salir negativo' },
          { tag: 'mejora', text: 'La lista de cobranza muestra también a los expositores dados de baja o sin contrato vigente que igual tienen letras del mes, marcados como tales: antes desaparecían de la lista aunque debieran plata' },
          { tag: 'fix', text: 'Un expositor con varias letras en el mismo mes ya no aparece como "Pagado" por haber pagado solo la primera, y el botón de cobro abre la letra que falta' },
          { tag: 'mejora', text: 'Si lo emitido en el mes no coincide con los contratos vigentes, se avisa arriba con los nombres a revisar, en vez de esconder la diferencia dentro de una resta' },
          { tag: 'mejora', text: 'Cada fila de la lista muestra cuánto le falta pagar a ese expositor' }
        ]
      }
    ]
  },
  {
    date: '2026-08-21',
    title: 'Planilla y adjuntos: arreglos de subida de comprobantes',
    summary: 'Se arreglaron las subidas de archivos que estaban fallando en silencio (contratos en PDF, voucher del impuesto de una propiedad y estado de cuenta del inquilino) y varios detalles del voucher de la boleta de planilla.',
    versions: { web: '2.15.2' },
    sections: [
      {
        surface: 'web',
        items: [
          { tag: 'fix', text: 'Volvieron a funcionar tres subidas que fallaban sin avisar: el contrato de alquiler en PDF, el comprobante del impuesto de una propiedad y el estado de cuenta del inquilino' },
          { tag: 'fix', text: 'Planilla: al adjuntar varios vouchers de una vez, las miniaturas ya no se mezclan y quitar una borra el archivo correcto' },
          { tag: 'fix', text: 'Planilla: al tocar "Finalizar boleta" el formulario de pago se muestra en pantalla (antes quedaba abajo, sin verse, en boletas con varios ajustes)' },
          { tag: 'fix', text: 'Planilla: si el archivo elegido no es una imagen ahora te avisa, en vez de no hacer nada; y los descuentos se muestran como -S/ 80.00' },
          { tag: 'seguridad', text: 'El módulo de Planilla ahora solo abre para administradores: antes cualquier cuenta con sesión podía llegar escribiendo la dirección' }
        ]
      }
    ]
  },
  {
    date: '2026-08-17',
    title: 'Recaudación: el "Recaudado" cuenta la letra por su mes de vencimiento',
    summary: 'El "Recaudado" ahora suma las letras pagadas del mes según su fecha de VENCIMIENTO: si una letra de junio se paga en julio, cuenta para junio (el mes al que corresponde). Así el "Pendiente" refleja de verdad quién no pagó la letra de su mes. El "Esperado" sigue siendo la suma de los contratos activos.',
    versions: { web: '2.15.1' },
    sections: [
      {
        surface: 'web',
        items: [
          { tag: 'fix', text: 'El "Recaudado" cuenta cada letra pagada en su mes de vencimiento (un pago atrasado se imputa al mes de la letra, no al mes en que se pagó); reemplaza el criterio por fecha de pago del release anterior, que hacía que el Recaudado superara al Esperado y el Pendiente saliera negativo cuando había prepagos o pagos atrasados' }
        ]
      }
    ]
  },
  {
    date: '2026-08-16',
    title: 'Planilla: corregido el guardado de ajustes en la boleta',
    summary: 'Se corrigió un error que impedía guardar un ajuste en la boleta cuando la nota se dejaba vacía: mostraba "Error al guardar boleta" y no guardaba nada.',
    versions: { web: '2.14.1' },
    sections: [
      {
        surface: 'web',
        items: [
          { tag: 'fix', text: 'Agregar un ajuste sin nota ya no bloquea el guardado de la boleta' }
        ]
      }
    ]
  },
  {
    date: '2026-08-14',
    title: 'Planilla: voucher del depósito por trabajador',
    summary: 'Ahora podés adjuntar el comprobante (voucher) del depósito de cada trabajador en su boleta: al registrar el pago o después, sobre una boleta ya pagada.',
    versions: { web: '2.14.0' },
    sections: [
      {
        surface: 'web',
        items: [
          { tag: 'nuevo', text: 'Adjuntar el voucher del depósito de cada trabajador en su boleta (imágenes) — al registrar el pago o luego, sobre una boleta ya finalizada; se ven en miniatura y se abren a tamaño completo' }
        ]
      }
    ]
  },
  {
    date: '2026-08-14',
    title: 'Planilla: datos de depósito completos al pagar',
    summary: 'En el detalle de la boleta, el N° de cuenta, el CCI y el celular (Yape/Plin) ahora se muestran completos, para poder copiarlos y hacer el depósito sin adivinar.',
    versions: { web: '2.13.1' },
    sections: [
      {
        surface: 'web',
        items: [
          { tag: 'fix', text: 'El destino de depósito ya no oculta el N° de cuenta, CCI ni celular: se muestran completos al momento de pagar' }
        ]
      }
    ]
  },
  {
    date: '2026-08-14',
    title: 'Planilla: filtro por local, cierre en bloque y rediseño',
    summary: 'Ahora la planilla se filtra por local, podés cerrar una quincena completa de una sola vez (en vez de boleta por boleta), el cargo del personal es una lista desplegable, y el módulo tiene un rediseño visual más claro.',
    versions: { web: '2.13.0' },
    sections: [
      {
        surface: 'web',
        items: [
          { tag: 'nuevo', text: 'Filtro por local en la planilla (solo aparecen los locales con personal), con búsqueda, orden y filtro por estado de boleta' },
          { tag: 'nuevo', text: 'Cerrar una quincena completa de una sola vez ("Cerrar quincena"), en vez de finalizar boleta por boleta' },
          { tag: 'nuevo', text: 'Exportar la planilla del mes a Excel' },
          { tag: 'nuevo', text: 'El cargo del personal ahora es una lista desplegable (Seguridad, Limpieza, Administración… + Otro)' },
          { tag: 'mejora', text: 'Rediseño visual del módulo de planilla: indicadores con color, estados con ícono y el detalle de boleta más ancho y ordenado' }
        ]
      }
    ]
  },
  {
    date: '2026-08-13',
    title: 'Planilla por quincena + datos de depósito del personal',
    summary: 'La planilla ahora se maneja por quincena: cada mes se divide en 1ª y 2ª quincena, cada una con su propio pago y fecha. Además ahora podés registrar cómo se le paga a cada trabajador: Ahorros/Corriente (con banco, número de cuenta y CCI) o Yape/Plin (con celular), datos que aparecen en la boleta al momento de pagar.',
    versions: { web: '2.12.0' },
    sections: [
      {
        surface: 'web',
        items: [
          { tag: 'nuevo', text: 'Planilla por quincena: cada mes se divide en 1ª y 2ª quincena, cada una con su pago y su fecha' },
          { tag: 'nuevo', text: 'Personal: forma de pago opcional — Ahorros/Corriente (banco + N° de cuenta + CCI) o Yape/Plin (celular)' },
          { tag: 'nuevo', text: 'Boleta de planilla: muestra el destino de depósito del trabajador al momento de pagar' }
        ]
      }
    ]
  },
  {
    date: '2026-08-08',
    title: 'Impuestos por mes y listado de propiedades más limpio',
    summary: 'El módulo de Impuestos ahora se navega por mes, igual que Recaudación y el Balance, con el selector de mes junto a los filtros de estado. Y el listado de Propiedades quedó más limpio.',
    versions: { web: '2.11.3' },
    sections: [
      {
        surface: 'web',
        items: [
          { tag: 'nuevo', text: 'Impuestos: navegación por mes (‹ Mes Año ›), consistente con Recaudación y Balance' },
          { tag: 'mejora', text: 'Impuestos: el selector de mes y los filtros de estado (Todos/Pendientes/Pagados) van en la misma fila' },
          { tag: 'mejora', text: 'Propiedades: listado más limpio, sin las iniciales ni los m² en cada fila' }
        ]
      }
    ]
  },
  {
    date: '2026-08-07',
    title: 'Detalle de propiedad: navegación y balance más claros',
    summary: 'Desde Recaudación ahora abrís el detalle de una propiedad con un ícono junto a su nombre; el botón de atrás vuelve a donde estabas; y el Balance separa la cobranza (esperado/recaudado/pendiente) del resultado (gastos y utilidad). Además, los montos en dólares usan el tipo de cambio del día en que se registró el gasto.',
    versions: { web: '2.11.2' },
    sections: [
      {
        surface: 'web',
        items: [
          { tag: 'nuevo', text: 'Recaudación: abrí el detalle de una propiedad con el ícono junto a su nombre' },
          { tag: 'mejora', text: 'Detalle de propiedad: el botón "atrás" vuelve a la pantalla anterior (no siempre al listado)' },
          { tag: 'mejora', text: 'Balance de la propiedad: se separa la cobranza (esperado/recaudado/pendiente) del resultado (gastos → utilidad)' },
          { tag: 'mejora', text: 'Tipo de cambio: los gastos guardan el TC del día en que se registran, para una conversión a dólares más exacta' }
        ]
      }
    ]
  },
  {
    date: '2026-08-07',
    title: 'Correcciones de interfaz en móvil',
    summary: 'Arreglamos que el menú lateral quedara tapado por la cabecera al abrirlo en móvil, y que la barra de mes/año no se desacomodara en pantallas angostas.',
    versions: { web: '2.11.1' },
    sections: [
      {
        surface: 'web',
        items: [
          { tag: 'fix', text: 'Móvil: el menú lateral ahora se abre por encima de la cabecera (antes quedaba tapado)' },
          { tag: 'fix', text: 'Móvil: la barra de mes/año y el botón de la cabecera ya no se desacomodan en pantallas angostas' }
        ]
      }
    ]
  },
  {
    date: '2026-08-07',
    title: 'Detalle financiero por propiedad',
    summary: 'Al entrar a una propiedad ahora ves su detalle financiero del mes: la recaudación (esperado, recaudado y pendiente), los gastos del local (operativos, prediales y planilla) y la utilidad. Disponible tanto en el panel web como en la app.',
    versions: { web: '2.11.0', app: '1.7.0' },
    sections: [
      {
        surface: 'web',
        items: [
          { tag: 'nuevo', text: 'Propiedades: al abrir una propiedad se ve su detalle financiero, con pestañas Balance, Recaudación, Gastos e Impuestos' },
          { tag: 'nuevo', text: 'Balance por propiedad: ingresos frente a gastos del local (operativos + prediales + planilla) y utilidad del mes' },
          { tag: 'nuevo', text: 'Personal: cada persona de planilla se asigna a un local, para atribuir la planilla por propiedad' }
        ]
      },
      {
        surface: 'app',
        items: [
          { tag: 'nuevo', text: 'Inicio: tocar una propiedad abre su detalle financiero del mes (recaudación, gastos y utilidad)' }
        ]
      }
    ]
  },
  {
    date: '2026-07-24',
    title: 'Mantenimiento interno de reportes',
    summary: 'Simplificamos por dentro el cálculo de ingresos y egresos: ahora se derivan directamente de la base de datos, sin la capa intermedia anterior. No cambia lo que ves en pantalla; es mantenimiento y consistencia.',
    versions: {},
    sections: [
      {
        surface: 'web',
        items: [
          { tag: 'mejora', text: 'Ingresos y egresos se calculan directamente desde la base de datos (se retiró la capa de reportes heredada)' }
        ]
      }
    ]
  },
  {
    date: '2026-07-17',
    title: 'Atajo a Inquilinos por propiedad (app)',
    summary: 'En la app, tocar una propiedad en el Inicio ahora abre la lista de Inquilinos ya filtrada por esa propiedad. Además, en Inquilinos los filtros por propiedad se ordenan por monto esperado, igual que el Inicio.',
    versions: { app: '1.6.1' },
    sections: [
      {
        surface: 'app',
        items: [
          { tag: 'nuevo', text: 'Inicio: tocar una propiedad abre Inquilinos ya filtrado por esa propiedad' },
          { tag: 'mejora', text: 'Inquilinos: los filtros por propiedad se ordenan por monto esperado' }
        ]
      }
    ]
  },
  {
    date: '2026-07-17',
    title: 'Gastos y balance del mes en la app',
    summary: 'La app suma el módulo de Gastos: el administrador ve los gastos del mes y puede registrar uno nuevo (local, tipo, moneda, monto y fecha). Además, el Inicio estrena la vista Balance, que muestra los ingresos frente a los gastos del mes —incluida la planilla— y la utilidad.',
    versions: { app: '1.6.0' },
    sections: [
      {
        surface: 'app',
        items: [
          { tag: 'nuevo', text: 'Módulo de Gastos: ver los gastos del mes y registrar uno nuevo desde la app' },
          { tag: 'nuevo', text: 'Inicio: nueva vista Balance con Ingresos vs Gastos del mes (incluye planilla) y la utilidad' }
        ]
      }
    ]
  },
  {
    date: '2026-07-16',
    title: 'Inicio ordenado por recaudación (app)',
    summary: 'En la app, la pantalla de Inicio ordena las propiedades de mayor a menor monto recaudado del mes, para ver primero las que más aportan.',
    versions: { app: '1.5.1' },
    sections: [
      {
        surface: 'app',
        items: [
          { tag: 'mejora', text: 'El Inicio lista las propiedades ordenadas por monto recaudado (de mayor a menor)' }
        ]
      }
    ]
  },
  {
    date: '2026-07-16',
    title: 'Ventas siempre en soles',
    summary: 'El registro de ventas queda fijo en soles: se retiró el selector de moneda al crear o editar una venta (las ventas siempre son en S/, el alquiler sigue en dólares). Evita que se registre una venta en la moneda equivocada por error.',
    versions: { web: '2.10.1' },
    sections: [
      {
        surface: 'web',
        items: [
          { tag: 'mejora', text: 'Nueva venta y editar venta ya no piden moneda: toda venta se registra en soles (S/). El alquiler se mantiene en dólares' }
        ]
      }
    ]
  },
  {
    date: '2026-07-16',
    title: 'Ventas por expositor, filtro de fechas con atajos y vistas más consistentes',
    summary: 'Ventas ahora agrupa los comprobantes por expositor: al abrir uno ves el detalle de sus ventas y el total del periodo por moneda. Estrenamos un filtro de fechas con atajos (Hoy, Esta semana, Este mes…) y calendario de rango. Estadísticas se integró en Ventas (con Exportar a Excel y reporte imprimible por expositor) y Propiedades adopta el mismo diseño de lista que Expositores.',
    versions: { web: '2.10.0' },
    sections: [
      {
        surface: 'web',
        items: [
          { tag: 'nuevo', text: 'Ventas agrupa los comprobantes por expositor; al abrir un expositor se ve el detalle de sus ventas y el total del periodo (S/ y $ se muestran por separado, nunca mezclados)' },
          { tag: 'nuevo', text: 'Filtro de fechas con atajos (Hoy, Esta semana, Este mes, Mes pasado, Este año, Todo) y calendario para rango personalizado' },
          { tag: 'nuevo', text: 'Franja de totales en Ventas: total vendido, N° de ventas y de expositores del periodo' },
          { tag: 'mejora', text: 'Estadísticas se integró en Ventas: filtro por local, Exportar a Excel y reporte imprimible por expositor' },
          { tag: 'mejora', text: 'Propiedades usa el mismo diseño de lista que Expositores, para una experiencia consistente' },
          { tag: 'fix', text: 'Los totales de ventas ya no suman soles y dólares juntos; cada moneda va por separado con su símbolo' },
          { tag: 'eliminado', text: 'Se retiró la sección Estadísticas del menú (su contenido vive ahora en Ventas)' }
        ]
      }
    ]
  },
  {
    date: '2026-07-15',
    title: 'Aviso de pago de letra más claro',
    summary: 'Cuando un expositor paga una letra, el aviso que reciben los administradores ahora muestra el monto, el local y el mes en el título, y el nombre del expositor en la descripción.',
    versions: { app: '1.5.0' },
    sections: [
      {
        surface: 'app',
        items: [
          { tag: 'mejora', text: 'El aviso de "letra pagada" muestra en el título el monto (con su moneda), el local y el mes (ej. "US$ 500.00 · Galería Ascope · Julio 2026"); el nombre del expositor pasa a la descripción' }
        ]
      }
    ]
  },
  {
    date: '2026-07-15',
    title: 'Solo administradores entran a la sección Administradores',
    summary: 'La pantalla de Administradores ahora exige rol de administrador para abrirse: una cuenta sin ese permiso ya no puede ver ni intentar gestionar la lista de administradores.',
    versions: { web: '2.9.1' },
    sections: [
      {
        surface: 'web',
        items: [
          { tag: 'seguridad', text: 'La sección "Administradores" solo es accesible para cuentas con rol de administrador; el resto queda fuera aunque haya iniciado sesión' }
        ]
      }
    ]
  },
  {
    date: '2026-07-15',
    title: 'Ordenar los listados',
    summary: 'Ahora puedes ordenar cada listado del panel con el control "Ordenar". Recaudación abre ordenada por mayor monto esperado.',
    versions: { web: '2.9.0' },
    sections: [
      {
        surface: 'web',
        items: [
          { tag: 'nuevo', text: 'Control "Ordenar" en todos los listados: Propiedades, Expositores, Letras, Impuestos, Contratos, Gastos, Ventas, Planilla, Administradores y Letras pendientes' },
          { tag: 'nuevo', text: 'Recaudación: ordena las propiedades por monto recaudado, % de avance, monto esperado, más atrasados o nombre; abre por mayor monto esperado' },
          { tag: 'mejora', text: 'El orden alfabético ignora espacios sobrantes en los nombres, así que ya no salen fuera de lugar' }
        ]
      }
    ]
  },
  {
    date: '2026-07-14',
    title: 'Recaudación es la pantalla principal',
    summary: 'Al ingresar, el panel abre directamente en Recaudación. Se eliminó la pantalla Dashboard: su información de alertas se consulta desde "Ver pendientes".',
    versions: { web: '2.8.0' },
    sections: [
      {
        surface: 'web',
        items: [
          { tag: 'mejora', text: 'Contratos: rediseñado con el nuevo estilo — tabla consistente, filtros Todos/Activos/Vencidos, estado vacío y acciones (editar, ver PDF, eliminar)' },
          { tag: 'mejora', text: 'Impuestos de propiedad: rediseñado con el nuevo estilo — cabecera, filtros de estado, tabla consistente y estado vacío' },
          { tag: 'fix', text: 'Detalle de expositor: el botón de agregar es consistente ("+ Agregar") en Letras, Impuestos y Contratos' },
          { tag: 'fix', text: 'Expositores: los botones de editar, notificar y gestionar acceso volvieron a aparecer en cada fila (estaban colapsados e invisibles)' },
          { tag: 'eliminado', text: 'Pantalla "Dashboard" retirada del menú' },
          { tag: 'mejora', text: 'Recaudación es ahora la pantalla de inicio — se abre al ingresar al panel' },
          { tag: 'mejora', text: 'Las letras vencidas y por vencer se consultan desde el botón "Ver pendientes"' }
        ]
      }
    ]
  },
  {
    date: '2026-07-14',
    title: 'Crear administradores con contraseña',
    summary: 'Ahora el panel permite dar de alta administradores nuevos definiendo su email y contraseña en un solo paso. Si la persona ya tenía cuenta en Inqi, solo se le otorga el acceso admin sin cambiar su contraseña.',
    versions: { web: '2.7.0' },
    sections: [
      {
        surface: 'web',
        items: [
          { tag: 'nuevo', text: 'Alta de administradores nuevos: crea la cuenta con email + contraseña y otorga el acceso admin en un solo paso' },
          { tag: 'mejora', text: 'Si el email ya tiene cuenta en Inqi, se le otorga admin sin tocar su contraseña' },
          { tag: 'fix', text: 'Mensajes de error claros al agregar administrador (email ya registrado, contraseña muy corta)' }
        ]
      }
    ]
  },
  {
    date: '2026-07-14',
    title: 'Módulo de Planilla',
    summary: 'Gestión de planilla mensual del personal: colaboradores fijos (sueldo mensual) y variables (por hora o día), con ajustes, extras y flujo de boletas (borrador → finalizar → anular).',
    versions: { web: '2.6.0' },
    sections: [
      {
        surface: 'web',
        items: [
          { tag: 'nuevo', text: 'Módulo /planilla con dos vistas: Personal y Planilla del mes' },
          { tag: 'nuevo', text: 'Registro de personal con tipo Fijo (sueldo mensual) o Variable (tarifa por hora/día)' },
          { tag: 'nuevo', text: 'Generación de planilla mensual: crea boletas en borrador para todo el personal activo' },
          { tag: 'nuevo', text: 'Boletas variables: el admin ingresa horas/días trabajados y el monto se calcula automáticamente' },
          { tag: 'nuevo', text: 'Ajustes por boleta: horas extra, bonos, descuentos, faltas, adelantos — con signo y notas' },
          { tag: 'nuevo', text: 'Flujo de boleta: borrador → registrar fecha y método de pago → finalizar (inmutable) → anular si hay corrección' },
          { tag: 'nuevo', text: 'KPI cards por período: bruto total, descuentos, neto y conteo de boletas finalizadas' }
        ]
      }
    ]
  },
  {
    date: '2026-07-13',
    title: 'Correcciones de diseño — auditoría completa',
    summary: 'Corrección de 100 hallazgos del audit de diseño: tokens DS aplicados en todos los módulos, chips, contadores, estado de filas y semántica de badges.',
    versions: { web: '2.5.0' },
    sections: [
      {
        surface: 'web',
        items: [
          { tag: 'fix', text: 'Todos los inline styles reemplazados por clases del DS (.btn--sm, .filter-bar--no-top, .dt-cell--, .select--compact, etc.)' },
          { tag: 'fix', text: 'KPI cards vuelven a usarse en Dashboard y Estadísticas en lugar de divs con inline styles' },
          { tag: 'fix', text: 'Chips de filtro ahora son negros cuando activos (Ruta Intermedia §3.3) y el contador es visible en chips inactivos' },
          { tag: 'fix', text: 'Filas de inquilinos con franja vertical 3px de estado (::before) en lugar de fondo tintado completo' },
          { tag: 'fix', text: 'ChipsBar v-model funciona correctamente en todos los módulos (fix Vue 2 model option)' },
          { tag: 'fix', text: 'Contadores del hero sincronizados con el conjunto visible, no con el total sin filtrar' },
          { tag: 'fix', text: 'Badges con modificadores explícitos (badge--success, badge--error) en todos los módulos' },
          { tag: 'fix', text: 'Hairline correcto (#E4E4E7) más visible según HANDOFF §2.4' },
          { tag: 'fix', text: 'Barras de progreso planas (sin border-radius) según HANDOFF §2.4' },
          { tag: 'fix', text: 'Selector &---block (triple guión) corregido a &--block en _btn.scss' }
        ]
      }
    ]
  },
  {
    date: '2026-07-13',
    title: 'Nuevo lenguaje visual — Ruta Intermedia',
    summary: 'El panel adopta la dirección visual definida para el producto: hero con número protagonista, chips de filtro y filas hairline para propiedades e inquilinos.',
    versions: { web: '2.4.0' },
    sections: [
      {
        surface: 'web',
        items: [
          { tag: 'nuevo', text: 'Hero header en todas las páginas — eyebrow ALL CAPS en granate, título 28px, número protagonista 44px' },
          { tag: 'nuevo', text: 'Chips de filtro (Todos / Atrasados / Por vencer / Al día) reemplazan dropdowns en Inquilinos, Gastos, Letras y Ventas' },
          { tag: 'nuevo', text: 'Propiedades: lista hairline con nombre, dirección y propietario — sin cards con sombra' },
          { tag: 'nuevo', text: 'Inquilinos: lista hairline con avatar de iniciales con tint de estado (rojo / naranja / verde)' },
          { tag: 'mejora', text: 'Dashboard y Recaudación: mini-stats tipográficos en lugar de cards independientes' },
          { tag: 'mejora', text: 'Admins: lista hairline con avatar de iniciales igual a Inquilinos' }
        ]
      }
    ]
  },
  {
    date: '2026-07-12',
    title: 'Rediseño completo del panel',
    summary: 'Nuevo look y mejor experiencia en todos los módulos: tablas más legibles, filtros siempre visibles, búsqueda en cada vista y métricas en el dashboard.',
    versions: { web: '2.3.0' },
    sections: [
      {
        surface: 'web',
        items: [
          { tag: 'mejora', text: 'Nuevo design system — paleta renovada, tablas en lugar de cards, filtros siempre visibles sin panel flotante' },
          { tag: 'nuevo', text: 'Dashboard unificado con 4 KPIs y tabla de alertas (letras vencidas + contratos por vencer) con botón de acción directo' },
          { tag: 'mejora', text: 'Recaudación: tabla de propiedades expandible con inquilinos y botón "Registrar pago" inline' },
          { tag: 'mejora', text: 'Letras pendientes: búsqueda por inquilino, badge de días vencido/restante, paginación' },
          { tag: 'mejora', text: 'Inquilinos: tabla con renta, contrato y estado de pago; filtros por propiedad, estado y pago' },
          { tag: 'mejora', text: 'Letras: nueva columna de comprobantes con alerta de voucher del cliente pendiente de confirmar' },
          { tag: 'mejora', text: 'Gastos: filtros predefinidos (este mes / mes anterior / todo), búsqueda por tipo' },
          { tag: 'mejora', text: 'Ventas: fecha inicial = mes actual completo (antes solo el día de hoy), búsqueda por expositor' },
          { tag: 'mejora', text: 'Estadísticas: búsqueda de expositor en tiempo real, filtros con presets de mes' },
          { tag: 'mejora', text: 'Propiedades: tabla con búsqueda por nombre, dirección y propietario' },
          { tag: 'fix', text: 'Estadísticas: eliminar import de moment sin usar que generaba warning de build' },
          { tag: 'fix', text: 'Dashboard y Tenants: corrección de espaciado en arrays de meses (lint)' },
          { tag: 'fix', text: 'Tablas y cards: quitar líneas de color en KPI cards, padding consistente en celdas, badges correctos en mobile, selects con estilo unificado' },
          { tag: 'fix', text: 'Inquilinos: import de storage corregido, moment eliminado, chips con valores semánticos (overdue/ok), eyebrow contextual' },
          { tag: 'fix', text: 'Inquilinos: avatar roto (CSS grid de collection.scss sobreescribía flex layout) y padding del filtro restaurado' },
          { tag: 'fix', text: 'Chips de filtro: padding superior para separarse del hero header' },
          { tag: 'mejora', text: 'Registrar pago: si el monto es menor al de la letra, el sistema pregunta si crear una nueva letra por la diferencia y solicita la fecha de vencimiento' },
          { tag: 'fix', text: 'Recaudación: botón "Registrar pago" siempre visible en el detalle de cada local — corrige descuadre del estado Pendiente' },
          { tag: 'fix', text: 'Recaudación: el click en cada local ahora despliega correctamente el detalle de expositores' },
          { tag: 'mejora', text: 'Recaudación: click en cada local despliega el detalle de expositores con animación — chevron indica qué propiedades están abiertas' },
          { tag: 'mejora', text: 'Recaudación: propiedades ahora usan filas hairline con barra de progreso; al expandir muestra expositores con estado y mes de letra pendiente' },
          { tag: 'mejora', text: 'Gastos: shortcuts de fecha (Este mes/Mes anterior/Todo) dentro de la barra de búsqueda; chips solo para estado de pago' },
          { tag: 'mejora', text: 'Ventas: clientes se cargan solo al abrir el formulario de nueva venta; chip de período se deselecciona al editar fechas manualmente' },
          { tag: 'nuevo', text: 'Letras pendientes: chips de filtro rápido Todos / Vencidos / Por vencer' },
          { tag: 'mejora', text: 'Dashboard: métricas de alertas como números tipográficos directos, sin cards con bordes' },
          { tag: 'fix', text: 'Expositores: algunos aparecían como "Atrasado" teniendo todas sus letras pagadas (o al revés) — corregido el estado de 6 expositores y blindado contra futuras desincronizaciones' },
          { tag: 'mejora', text: 'Recaudación: el monto esperado por local ("de $X") es más grande y legible' },
          { tag: 'fix', text: 'Dashboard: el tipo de alerta (LETRA/CONTRATO) se muestra como texto de color legible, no como etiqueta con texto negro sobre fondo rojo' },
          { tag: 'mejora', text: 'Encabezado: más separación entre el rótulo de sección y el título' },
          { tag: 'fix', text: 'Chips de filtro: separación superior del encabezado (ya no quedan pegados al borde del card)' },
          { tag: 'mejora', text: 'Navegación por pestañas: en el detalle de expositor (Letras/Impuestos/Contratos) y en Planilla ahora se usan pestañas con subrayado, no chips — los chips quedan reservados solo para filtros' },
          { tag: 'mejora', text: 'Chips de filtro: borde más visible, contadores legibles, tamaño 32px y fuente 12px' },
          { tag: 'mejora', text: 'Barra de filtros: fondo transparente integrado en la página, inputs blancos con buen contraste, botones de período en forma de chip, ícono de calendario nativo eliminado' },
          { tag: 'fix', text: 'Todas las secciones: el encabezado blanco ahora tiene el padding superior correcto' },
          { tag: 'fix', text: 'Expositores: columna derecha muestra siempre renta/mes y fecha de atraso cuando está disponible' },
          { tag: 'fix', text: 'Expositores: nombres muy largos se truncan con ellipsis en lugar de desbordar el layout' },
          { tag: 'fix', text: 'Dashboard: quita columna "TIPO" redundante de la tabla de alertas; el tipo se muestra como texto en la línea secundaria del inquilino' },
          { tag: 'fix', text: 'Dashboard: "Ver pendientes" ahora es el botón primario (rojo sólido); badge "75D VENCIDO" sin corte de línea' },
          { tag: 'fix', text: 'Expositores: la fecha de atraso ahora dice "desde may. 2026" con contexto claro' },
          { tag: 'mejora', text: 'Recaudación: chevron de expansión más visible con fondo gris; separador más marcado entre métricas y lista de locales' },
          { tag: 'fix', text: 'Expositores: corregido error que dejaba la lista en blanco al restaurar los avatares' },
          { tag: 'mejora', text: 'Expositores: avatares con iniciales en colores según estado de pago' },
          { tag: 'mejora', text: 'Impuestos: rediseñado con tabla del nuevo sistema, chips de filtro y estado vacío' },
          { tag: 'fix', text: 'Detalle de expositor: no repite el nombre en la línea de metadatos; título del hero se trunca si es muy largo' },
          { tag: 'fix', text: 'Gastos: botones de período activos en negro sólido; "1 gasto" con plural correcto' },
          { tag: 'mejora', text: 'Accesibilidad: todos los botones, chips, inputs y iconos ahora muestran un anillo de foco visible al navegar con teclado (WCAG 2.4.7)' },
          { tag: 'fix', text: 'El estado "Al día" de expositores ahora es gris neutro en lugar de verde — el verde queda reservado para acciones completadas' },
          { tag: 'fix', text: 'El porcentaje de recaudación por local ahora cambia de color según el nivel: verde ≥80%, naranja ≥50%, rojo <50%' },
          { tag: 'mejora', text: 'Detalle de expositor: los botones de acción (Generar letras, Notificar, Agregar) ahora están en la cabecera junto al nombre del expositor, no enterrados bajo las pestañas' },
          { tag: 'fix', text: 'Inquilinos: franja gris entre chips y buscador eliminada (padding superior del filtro corregido)' },
          { tag: 'fix', text: 'Inquilinos: quitar letra/avatar al lado del nombre de cada expositor' },
          { tag: 'mejora', text: 'Inquilinos: la fila de un expositor atrasado muestra el mes de la letra pendiente (ej. "Jul 2026") sin queries extra al abrir el listado' }
        ]
      }
    ]
  },
  {
    date: '2026-07-12',
    title: 'Gestión de administradores',
    summary: 'Nueva sección para agregar y revocar accesos de administradores del panel.',
    versions: { web: '2.2.0' },
    sections: [
      {
        surface: 'web',
        items: [
          { tag: 'nuevo', text: 'Sección Administradores — lista todos los admins con nombre, documento y fecha de alta' },
          { tag: 'admin', text: 'Agregar un administrador por email desde el panel — el acceso se activa al reiniciar sesión' },
          { tag: 'admin', text: 'Revocar acceso de un administrador con confirmación' }
        ]
      }
    ]
  },
  {
    date: '2026-07-10',
    title: 'Guía del panel · Push mejorado',
    summary: 'Nueva guía interactiva del panel. La notificación de pago ahora muestra el mes entre corchetes para identificarlo de un vistazo.',
    versions: { web: '2.1.0' },
    sections: [
      {
        surface: 'web',
        items: [
          { tag: 'nuevo', text: 'Guía interactiva del panel en /onboarding — 12 slides con flujo de trabajo, alertas del Dashboard, campos obligatorios y opcionales de cada módulo, y explicación del modelo de datos' }
        ]
      },
      {
        surface: 'app',
        items: [
          { tag: 'mejora', text: 'La notificación de pago muestra el mes entre corchetes — "[julio 2026] · Local 3B" — para identificarlo de un vistazo' }
        ]
      }
    ]
  },
  {
    date: '2026-07-06',
    title: 'Notificación de pago mejorada',
    summary: 'La push notification al registrar un pago ahora muestra el mes/año de la letra y el local en el cuerpo.',
    versions: {},
    sections: [
      {
        surface: 'app',
        items: [
          { tag: 'mejora', text: 'Al marcar una letra como pagada, la notificación push muestra el nombre del inquilino y monto en el título, y el mes/año junto al local en el cuerpo' }
        ]
      }
    ]
  },
  {
    date: '2026-07-05',
    title: 'Navegación por tabs en el detalle del cliente',
    summary: 'Al entrar a un cliente ahora puedes cambiar entre Letras, Impuestos y Contratos sin volver al listado.',
    versions: { web: '2.0.0' },
    sections: [
      {
        surface: 'web',
        items: [
          { tag: 'mejora', text: 'Nueva vista de detalle del cliente con pestañas Letras / Impuestos / Contratos — sin salir y volver a buscar' },
          { tag: 'fix', text: 'Las letras e impuestos de contratos anteriores volvían a mostrarse correctamente al renovar un contrato' },
          { tag: 'fix', text: 'La fecha de pago de letras pendientes ya no muestra "Fecha inválida"' }
        ]
      }
    ]
  },
  {
    date: '2026-06-26',
    title: 'Gestión de acceso de expositores',
    summary: 'Desde el panel ahora se puede resetear la contraseña o revocar el acceso de un expositor.',
    versions: { web: '1.9.0' },
    sections: [
      {
        surface: 'web',
        items: [
          { tag: 'admin', text: 'Nuevo botón "Gestionar acceso" en cada inquilino con acceso: ver el usuario de login, resetear su contraseña y revocar el acceso' }
        ]
      }
    ]
  },
  {
    date: '2026-06-26',
    title: 'Acceso de expositores',
    summary: 'Los expositores ahora pueden ingresar a la app para ver sus letras y ventas, y enviar sus comprobantes de pago.',
    versions: { web: '1.8.0', app: '1.5.0' },
    sections: [
      {
        surface: 'app',
        items: [
          { tag: 'nuevo', text: 'Los expositores pueden iniciar sesión y ver únicamente sus propias letras y sus propias ventas' },
          { tag: 'nuevo', text: 'Desde una letra pendiente, el expositor puede enviar su comprobante de pago para que el administrador lo confirme' },
          { tag: 'seguridad', text: 'Cada expositor solo accede a su propia información; no puede ver datos de otros ni totales del negocio' },
          { tag: 'nuevo', text: 'Mis letras ahora tiene dos pestañas: Pendientes (con las vencidas primero) y Pagadas' },
          { tag: 'mejora', text: 'Los montos muestran el símbolo de moneda correcto ($ / S/) y las fechas de vencimiento son más claras' }
        ]
      },
      {
        surface: 'web',
        items: [
          { tag: 'admin', text: 'Nueva acción "Crear acceso" en cada inquilino para darle al expositor una cuenta de ingreso a la app' }
        ]
      }
    ]
  },
  {
    date: '2026-06-17',
    title: 'Filtro de gastos por fecha',
    summary: 'Al filtrar gastos por fecha ahora se ven todos los gastos del rango.',
    versions: { web: '1.7.1' },
    sections: [
      {
        surface: 'web',
        items: [
          { tag: 'fix', text: 'El filtro de gastos por fecha ahora muestra todos los gastos (pagados y no pagados) e incluye el último día completo' }
        ]
      }
    ]
  },
  {
    date: '2026-06-17',
    title: 'Listados paginados',
    summary: 'Los listados de gastos y ventas ahora se muestran de 20 en 20.',
    versions: { web: '1.7.0' },
    sections: [
      {
        surface: 'web',
        items: [
          { tag: 'mejora', text: 'Los listados de gastos y ventas se paginan de 20 en 20' }
        ]
      }
    ]
  },
  {
    date: '2026-06-17',
    title: 'Gastos al instante',
    summary: 'Los gastos recién registrados aparecen de inmediato en el listado.',
    versions: { web: '1.6.1' },
    sections: [
      {
        surface: 'web',
        items: [
          { tag: 'fix', text: 'Al registrar un gasto ahora aparece al inicio del listado sin recargar' }
        ]
      }
    ]
  },
  {
    date: '2026-06-14',
    title: 'Ventas',
    summary: 'Mejoras al módulo de ventas en el panel y una nueva sección de ventas en la app.',
    versions: { web: '1.6.0', app: '1.3.0' },
    sections: [
      {
        surface: 'web',
        items: [
          { tag: 'nuevo', text: 'Buscar expositores en las estadísticas de ventas' },
          { tag: 'nuevo', text: 'Generar un reporte imprimible de ventas por expositor' },
          { tag: 'fix', text: 'Corregir la exportación a Excel de las estadísticas de ventas' }
        ]
      },
      {
        surface: 'app',
        items: [
          { tag: 'nuevo', text: 'Nueva sección de Ventas con el detalle por expositor del mes' }
        ]
      }
    ]
  },
  {
    date: '2026-06-09',
    title: 'Historial de cambios público',
    summary: 'El historial de novedades ahora es público: se consulta sin iniciar sesión.',
    versions: { web: '1.5.1' },
    sections: [
      {
        surface: 'web',
        items: [
          { tag: 'mejora', text: 'El historial de cambios se puede consultar sin iniciar sesión' }
        ]
      }
    ]
  },
  {
    date: '2026-06-09',
    title: 'Recaudación en lugar de morosidad',
    summary: 'El indicador del mes ahora resalta lo recaudado en vez de la morosidad.',
    versions: { web: '1.4.0', app: '1.2.0' },
    sections: [
      {
        surface: 'web',
        items: [
          { tag: 'mejora', text: 'El dashboard de recaudación muestra el % de recaudación del mes en vez de la morosidad' }
        ]
      },
      {
        surface: 'app',
        items: [
          { tag: 'mejora', text: 'El inicio muestra el % de recaudación del mes' }
        ]
      }
    ]
  },
  {
    date: '2026-06-03',
    title: 'Filtro por local en estadísticas',
    versions: { web: '1.3.0' },
    sections: [
      {
        surface: 'web',
        items: [
          { tag: 'nuevo', text: 'Filtro por local en el módulo de estadísticas' }
        ]
      }
    ]
  },
  {
    date: '2026-05-22',
    title: 'Notificaciones push',
    summary: 'Avisos automáticos al registrar pagos y una nueva página de novedades.',
    versions: { web: '1.2.0', app: '1.1.0' },
    sections: [
      {
        surface: 'web',
        items: [
          { tag: 'nuevo', text: 'Nueva página de novedades' }
        ]
      },
      {
        surface: 'app',
        items: [
          { tag: 'nuevo', text: 'Notificaciones push al registrar pagos' },
          { tag: 'fix', text: 'Corrección en el registro de notificaciones' }
        ]
      }
    ]
  },
  {
    date: '2026-04-27',
    title: 'Rediseño visual y mejoras de pago',
    versions: { web: '1.1.0', app: '1.0.0' },
    sections: [
      {
        surface: 'web',
        items: [
          { tag: 'mejora', text: 'Rediseño del modal de pago con tarjeta de detalle' },
          { tag: 'nuevo', text: 'Campo de observación en gastos' },
          { tag: 'fix', text: 'Formato de moneda en estadísticas corregido a S/' },
          { tag: 'fix', text: 'Estadísticas muestra el mes actual por defecto' }
        ]
      },
      {
        surface: 'app',
        items: [
          { tag: 'nuevo', text: 'App móvil disponible para iOS' }
        ]
      }
    ]
  },
  {
    date: '2026-04-26',
    title: 'Nuevo sistema visual',
    summary: 'Lanzamiento del nuevo sistema visual con la tipografía Inter.',
    versions: { web: '1.0.0', app: '1.0.0' },
    sections: [
      {
        surface: 'web',
        items: [
          { tag: 'mejora', text: 'Nuevo sistema visual con tipografía Inter' },
          { tag: 'nuevo', text: 'Página de soporte con email de contacto' },
          { tag: 'nuevo', text: 'Política de privacidad y términos de uso' }
        ]
      },
      {
        surface: 'app',
        items: [
          { tag: 'mejora', text: 'Layout responsivo para iPad' },
          { tag: 'mejora', text: 'Migración visual a diseño intermedio' }
        ]
      }
    ]
  },
  {
    date: '2026-04-25',
    title: 'Rediseño de propiedades y expositores',
    versions: { web: '0.4.0' },
    sections: [
      {
        surface: 'web',
        items: [
          { tag: 'mejora', text: 'Propiedades rediseñadas con cards y enlace a expositores' },
          { tag: 'mejora', text: 'Listado de expositores con nuevo layout de cards' },
          { tag: 'nuevo', text: 'Indicador de contratos por renovar en el dashboard' },
          { tag: 'nuevo', text: 'Soporte para múltiples vouchers de pago' },
          { tag: 'fix', text: 'Cálculo de recaudación esperada corregido' },
          { tag: 'fix', text: 'Formato de números corregido en todo el panel' }
        ]
      }
    ]
  },
  {
    date: '2026-04-20',
    title: 'Mejoras en ventas',
    versions: { web: '0.3.0' },
    sections: [
      {
        surface: 'web',
        items: [
          { tag: 'nuevo', text: 'Selección de inquilinos de todos los locales en ventas' },
          { tag: 'nuevo', text: 'Búsqueda en el selector de inquilinos' }
        ]
      }
    ]
  },
  {
    date: '2026-04-17',
    title: 'Correcciones de moneda y contratos',
    versions: { web: '0.2.1' },
    sections: [
      {
        surface: 'web',
        items: [
          { tag: 'fix', text: 'Error al formatear monedas vacías corregido' },
          { tag: 'fix', text: 'Listado de contratos ajustado' }
        ]
      }
    ]
  },
  {
    date: '2026-04-16',
    title: 'Gestión de letras y contratos',
    versions: { web: '0.2.0' },
    sections: [
      {
        surface: 'web',
        items: [
          { tag: 'nuevo', text: 'Eliminación de letras con confirmación' },
          { tag: 'nuevo', text: 'Eliminación de contratos con confirmación' },
          { tag: 'nuevo', text: 'Edición de letras desde modal' }
        ]
      }
    ]
  },
  {
    date: '2026-03-31',
    title: 'Mejoras generales',
    versions: { web: '0.1.0' },
    sections: [
      {
        surface: 'web',
        items: [
          { tag: 'mejora', text: 'Mejoras generales en la interfaz' }
        ]
      }
    ]
  }
]
